export default __webpack_public_path__ + "static/media/bird-waving.574c1db5.png";